import React, { useState, useEffect } from 'react';
import styles from './ManageUsers.module.css';
import { getUsers, deleteUser } from '../api/authApi';

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(null);

  useEffect(() => {
    getUsers()
      .then((response) => setUsers(response.data))
      .catch((error) => {
        console.error('Error fetching users:', error);
        setErrorMessage('Failed to fetch users. Please try again.');
      });
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDeleteClick = (username) => {
    setConfirmDelete(username);
  };

  const confirmDeleteUser = async () => {
    try {
      await deleteUser(confirmDelete);
      setUsers((prevUsers) => prevUsers.filter((user) => user.username !== confirmDelete));
      setSuccessMessage(`User '${confirmDelete}' deleted successfully.`);
      setConfirmDelete(null);
    } catch (error) {
      console.error('Error deleting user:', error);
      setErrorMessage('Failed to delete user. Please try again.');
    }
  };

  const filteredUsers = users.filter((user) =>
    user.username.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.manageUsersContainer}>
      <header className={styles.header}>
        <h1 className={styles.title}>Manage Users</h1>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search by username..."
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </header>

      <div className={styles.userList}>
        {filteredUsers.length > 0 ? (
          filteredUsers.map((user) => (
            <div key={user._id} className={styles.userCard}>
              <h2 className={styles.username}>{user.username}</h2>
              <p className={styles.userType}>
                <strong>Type:</strong> {user.userType}
              </p>
              <button
                className={styles.deleteButton}
                onClick={() => handleDeleteClick(user.username)}
              >
                Delete
              </button>
            </div>
          ))
        ) : (
          <p className={styles.noUsers}>No users found.</p>
        )}
      </div>

      {errorMessage && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modalContent}>
            <h2>Error</h2>
            <p>{errorMessage}</p>
            <button onClick={() => setErrorMessage(null)} className={styles.modalButton}>
              Close
            </button>
          </div>
        </div>
      )}

      {successMessage && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modalContent}>
            <h2>Success</h2>
            <p>{successMessage}</p>
            <button onClick={() => setSuccessMessage(null)} className={styles.modalButton}>
              Close
            </button>
          </div>
        </div>
      )}

      {confirmDelete && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modalContent}>
            <h2>Confirm Deletion</h2>
            <p>
              Are you sure you want to delete user <strong>{confirmDelete}</strong>?
            </p>
            <div className={styles.modalButtonGroup}>
              <button onClick={confirmDeleteUser} className={styles.confirmButton}>
                Yes, Delete
              </button>
              <button onClick={() => setConfirmDelete(null)} className={styles.cancelButton}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageUsers;
